import { memo, useCallback, useEffect } from 'react'
import { Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

import FilterWrapper from 'components/Shared/FilterBuilder/FilterWrapper'
import { AdminUITheme } from 'types/AdminUiThemeMui'
import {
  setFilters,
  resetFilters,
  updateFilter,
} from 'redux/slices/FilterBuilder'
import { AllAdmins } from 'lib/authorization/Roles'
import { useAppDispatch, useAppSelector } from 'redux/Hook'
import SharedFilters from 'components/Reporting/StakeholderDashboard/FilterBuilder/SharedFilters'
import { isMobileView, RANGE_TYPES } from 'lib/GlobalConstants'
import { getDateRange, calculateDateRange } from 'lib/DateHelper'
import DateRangeFilter from 'components/Reporting/Shared/Filters/OverviewDateRange'

const StakeHolderFilterBuilder = (props: any) => {
  const { isSharedDashboard } = props
  const dispatchStore = useAppDispatch()
  const theme: AdminUITheme = useTheme()
  const dispatch = useAppDispatch()
  const { areChipsHidden = false }: any = useAppSelector(
    (state) => state.stakeholderDashboardDetails,
  )
  const {
    filterBuilder: { selectedFilters },
    stakeholderDashboardDetails: { filterParams },
    site: { site: { createdAt = '' } = {} } = {},
  } = useAppSelector((state) => state)
  const { t } = useTranslation()

  const showSelectedFiltersOnUI = useCallback(() => {
    const mobileWidth = isMobileView ? { width: '100%' } : {}
    if (selectedFilters.length === 0) return

    const data = {
      index: 0,
      isAutoFocusEnabled: true,
      type: 'dateRange',
      item: { ...selectedFilters?.[0] },
      isSharedDashboard,
    }

    return (
      <Grid
        item
        key={0}
        style={{
          ...theme.ParticipantGrid.selectedFilterWidth,
          ...mobileWidth,
        }}
      >
        <DateRangeFilter {...data} />
      </Grid>
    )
  }, [selectedFilters])

  useEffect(() => {
    let updatedDateRangeParams = []

    const newDateRange = getDateRange('last_7_days', false)
    const calculatedRange7Days = calculateDateRange('last_7_days', newDateRange)
    if (isEmpty(filterParams)) {
      const item = {
        dateRange: newDateRange,
        calculatedRange: calculatedRange7Days,
        dateRangeOption: 'last_7_days',
      }

      updatedDateRangeParams = [
        {
          name: 'dateRange',
          disabled: true,
          isDefault: true,
          icon: 'date_range',
          component: 'DateRangeFilter',
          dateRangeOption: RANGE_TYPES.week,
          hidden: true,
          isSelected: true,
          allowedTo: [AllAdmins],
          calculatedRange: calculatedRange7Days,
          isDateRangePickerOpen: false,
          defaultOpen: false,
          dateRange: {
            ...item.dateRange,
            dateRangeOption: 'last_7_days',
          },
        },
        {},
      ]
      dispatch(updateFilter({ item, index: 0 }))
      dispatchStore(setFilters(updatedDateRangeParams))
    } else if (Array.isArray(filterParams)) {
      const [dateFilterParms, ...rest] = filterParams || [
        {
          name: 'dateRange',
          disabled: true,
          isDefault: true,
          icon: 'date_range',
          component: 'DateRangeFilter',
          dateRangeOption: RANGE_TYPES.week,
          hidden: true,
          isSelected: true,
          allowedTo: [AllAdmins],
          calculatedRange: '',
          isDateRangePickerOpen: false,
        },
        {},
      ]
      const dateFilter: string = dateFilterParms?.dateRangeOption
      const dateRange: any = dateFilterParms?.dateRange
      const updatedDateRange =
        dateFilter !== RANGE_TYPES.custom && createdAt
          ? getDateRange(dateFilter, false, createdAt)
          : dateRange
      const calculatedRange =
        dateFilter === 'all_time'
          ? t(`filters.dateRange.ranges.${RANGE_TYPES.allTime}`)
          : calculateDateRange(dateFilter, updatedDateRange)

      const item: any = {
        dateRange: {
          ...updatedDateRange,
        },
        calculatedRange,
      }

      updatedDateRangeParams = [{ ...dateFilterParms, ...item }, ...rest]
      dispatch(updateFilter({ item, index: 0 }))
      dispatchStore(setFilters(updatedDateRangeParams))
    }

    return () => {
      dispatch(resetFilters())
    }
  }, [])

  return (
    <Grid container sx={{ mb: 3 }}>
      <Grid item xs={12}>
        <FilterWrapper>
          <>
            {showSelectedFiltersOnUI()}

            {!areChipsHidden && <SharedFilters />}
          </>
        </FilterWrapper>
      </Grid>
    </Grid>
  )
}

export default memo(StakeHolderFilterBuilder)
